export default `
precision highp float;

varying vec2 vUv;
varying vec3 vNormal;

uniform sampler2D depth;
uniform float sampleStepX;
uniform float sampleStepY;

float getHeight(vec2 uv) {
	vec4 heightMapValue = texture2D(depth, uv);
	float height = heightMapValue.z;
    float circleHeight = sqrt(1. - (pow(1. - height, 1.5)) );
    circleHeight = sqrt(1. - (pow(1. - circleHeight, 4.0)) );
	return circleHeight + heightMapValue.x;
}

vec4 bumpFromDepth(vec2 uv, float scale) {
	float height = getHeight(uv);
	  
	vec2 dxy = height - vec2(
		getHeight(uv + vec2(sampleStepX, 0.)), 
		getHeight(uv + vec2(0., sampleStepY))
	);
	  
	return vec4(normalize(vec3(dxy * scale / sampleStepX, 1.)), height);
}
  

void main() {
	//vec4 depthColor = texture2D(depth, vUv);
	vec4 bumpNormal = bumpFromDepth(vUv, 1.0);
	bumpNormal.xyz = (bumpNormal.xyz + vec3(1.0)) / 2.0;
	gl_FragColor = bumpNormal;
}
`